Hop.defineModule('align', (root, param) => {
    const $root = $(root);
    let h = 0;
    const $targets = $root.find(param.target);
    const maxWidth = param.max_width || 10000;
    const minWidth = param.min_width || 0;
    const lastAlign = param.lastAlign || false; // used on homepage to detect last inside block alignment to align the two columns

    function align() {
        if (matchMedia('(min-width: ' + minWidth + 'px)').matches && matchMedia('(max-width: ' + maxWidth + 'px)').matches) {
            $targets.each((idx, el) => {
                const $el = $(el);
                if (h < $el.innerHeight()) {
                    h = $el.innerHeight();
                }
            });
            $targets.css('height', h);
        }
    }

    function resize() {
        $(window).trigger('resize');
        if (lastAlign) {
            $('body').trigger('alignReady');
        }
    }

    function reset() {
        $targets.removeAttr('style');
        align();
    }

    align();
    // wtf is this hack
    setTimeout(resize, 10);
    $(window).on('resize', reset);

    $('body').on('async-css-loaded', resize);
});
